<main id="main" class="main mb-5">
  <div class="row">
    <div class="col-md-12">
      <h6 class="admintitle">
        {{lang?.Provisioning_Queues}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <div class="row mt-3">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_0"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th></th>
            <th>{{lang?.Customer??"Customer"}}</th>
            <th>{{lang?.Execution_ID??"Execution ID"}}</th>
            <th>{{lang?.Date??"Date"}}</th>
            <th>{{lang?.Retry??"Retry"}}</th>
            <!-- <th class="text-center">Customer</th> -->
            <th>{{lang?.Plan_Data??"Plan Data"}}</th>
            <th>{{lang?.Payload??"Payload"}}</th>
            <th>{{lang?.Response??"Response"}}</th>
            <th>{{lang?.Misc_Data??"Misc Data"}}</th>
            <th>{{lang?.Status??"Status"}}</th>
            <th class="text-center">{{lang?.Actions??"Actions"}}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let provisioning of provisioningData; let i = index"
            class="my-auto"
            [ngClass]="{ 'highlighted-row': selectedRow === i }"
          >
          <td>
            <i *ngIf="provisioning?.service"
              style="font-size:14px;color: rgb(31,31,29);font-family: system-ui;font-weight: 600;"
              title="{{provisioning?.service.slice(0,1).toUpperCase()+provisioning?.service.slice(1)}}">{{provisioning?.service.slice(0,1).toUpperCase()}}</i>
          </td>
            <!-- <td>{{ provisioning.customerId }}</td> -->
            <td>{{ provisioning?.customer?.firstName??'-' }} <sub>{{ provisioning?.customerId }}</sub></td>
            <td>{{ provisioning?.executionId }}</td>
            <td>{{provisioning?.created | date: 'MM-dd-yyyy'}}</td>
            <td class="text-center">{{ provisioning?.retry }}</td>
            <!-- <td class="text-center">
              <a
                class="view"
                (click)="openModal(provisioning.customer, 'Customer information')"
                >View</a
              >
            </td> -->
            <td class="text-center">
              <a
                class="view"
                (click)="openModal(provisioning.planData, lang?.Plan_Data)"
                >{{lang?.View}}</a
              >
            </td>
            <td class="text-center">
              <a
                class="view"
                (click)="openModal(provisioning.payloadData, lang?.Payload_Data)"
                >{{lang?.View}}</a
              >
            </td>
            <td class="text-center">
              <a
                class="view"
                (click)="openModal(provisioning.responseData, lang?.Response_Data)"
                >{{lang?.View}}</a
              >
            </td>
            <td class="text-center">
              <a
                class="view"
                (click)="openModal(provisioning.miscData, lang?.Misc_Data)"
                >{{lang?.View}}</a
              >
            </td>
            <td class="status">
              <!-- <button
                class="provisioning-btn provisioning-{{ provisioning.status }}"
              >
                {{ provisioning.status }}
              </button> -->
              <span *ngIf="provisioning.status=='Failed'" style="color:red">{{lang?.Failed}}</span>
              <span *ngIf="provisioning.status=='Done'" style="color:green">{{lang?.Done}}</span>
              <!-- <span *ngIf="provisioning.status!='Done' && provisioning.status!='Failed'">{{ provisioning.status }}</span> -->
              <span *ngIf="provisioning.status=='Review'">{{ lang?.Review }}</span>
              <span *ngIf="provisioning.status=='Pending'">{{ lang?.Pending }}</span>
            </td>
            <td class="text-center actions">
              <a 
                class="icon"
                title="{{lang?.Video}}"
                data-bs-toggle="modal"
                data-bs-target="#popup-video"
                (click)="openVideo(provisioning.responseData)"
              ><i class="bi bi-camera-video" style="color: #111111"></i>&nbsp;</a>
              <a 
                class="icon"
                title="{{lang?.Log_File}}"
                data-bs-toggle="modal"
                data-bs-target="#popup-file"
                (click)="openFile(provisioning.responseData)"
              ><i class="bi bi-file-code" style="color: #111111"></i>&nbsp;</a>
              <a 
                class="icon"
                title="{{lang?.Image_File}}"
                data-bs-toggle="modal"
                data-bs-target="#popup-image"
                (click)="openImage(provisioning.responseData)"
              ><i class="bi bi-file-image" style="color: #111111"></i>&nbsp;</a>
              <a
                class="icon"
                title="{{lang?.Requeue}}"
                data-toggle="tooltip"
                (click)="handleRequeue(provisioning.id)"
                *ngIf="provisioning.status!='Done' && provisioning.status!='Review'"
              ><i class="fa fa-rotate-right" style="color: rgb(56, 76, 159)"></i>&nbsp;</a>
              <a
                class="icon"
                style="cursor: not-allowed;"
                data-toggle="tooltip"
                *ngIf="provisioning.status=='Done' || provisioning.status=='Review'"
              ><i class="bi bi-ban" style="color: gray"></i>&nbsp;</a>
              <a class="icon" title="{{lang?.Delete}}" data-toggle="tooltip" (click)="handleDelete(provisioning.id)"
                ><i class="bi bi-trash-fill" style="color: #dc3545"></i></a>
            </td>
            <!-- <td *ngIf="provisioning.status=='Done'"></td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal" id="dataModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
        </div>
        <div class="modal-body">
          <p style="float: right;">
            <i
              class="bi bi-clipboard-fill copy-to-clipboard"
              title="Copy to Clipboard"
              data-toggle="tooltip"
              (click)="copyToClipboard()"
            ></i>
          </p>
          <div id="jsonData"></div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            id="closeModal"
            #closemodel
          >
            {{lang?.Close}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- file popup -->
  <div id="popup-file" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="modal-label" style="display: none">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style id="heightWidthModal2">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" style="height: 40px">
          <div class="col-11 text-center">
            <h6 class="modal-title">{{lang?.Log_File}}</h6>
          </div>
        </div>
  
        <div class="modal-body" id="modal-body1">
            <!-- <p style="font-size: 12px;">{{fileUrl}}</p> -->
             <table 
              datatable 
              class="logfile" 
              [dtOptions]="dtOptions1"
              [dtTrigger]="dtTrigger1"
              id="DataTables_Table_1"
            >
              <thead>
                <tr>
                  <th *ngFor="let label of logLabels">{{label}}</th>
                </tr>
              </thead>
              <tbody *ngIf="logFileData?.length>0">
                <tr *ngFor="let obj of logFileData">
                  <td>{{ obj.timeStamp }}</td>
                  <td>{{ obj.logType }}</td>
                  <td>{{ obj.testCase }}</td>
                  <td>{{ obj.dataSet }}</td>
                  <td>{{ obj.stepNo }}</td>
                  <td>{{ obj.item }}</td>
                  <td>{{ obj.stepInfo }}</td>
                  <td>{{ obj.result }}</td>
                  <td>{{ obj.duration }}</td>
                </tr>
              </tbody>
              <tbody *ngIf="logFileData==undefined||logFileData==null||logFileData?.length==0">
                <!-- <tr><td [attr.colspan]="logLabels.length" class="text-center w-100">No Data Available</td></tr> -->
              </tbody>
             </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton" (click)="closeFile()">
            {{lang?.Close}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- video popup -->
  <div id="popup-video" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1" role="dialog"
   aria-labelledby="modal-label" style="display: none">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" id="heightWidthModal2">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" style="height: 40px">
          <div class="col-11 text-center">
            <h6 class="modal-title">Video</h6>
          </div>
        </div>

        <div class="modal-body" id="modal-body1">
          <!-- Video Player -->
          <video 
            style="height:100%; width: 100%; object-fit: contain; display:block; margin:auto;"
            *ngIf="videoUrl!=''"
            [src]="videoUrl"
            controls
            autoplay
            (error)="onVideoError()"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <ng-template #errorTemplate>
          <p>Cannot load video. Please try again later.</p>
        </ng-template>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- image popup -->
  <div id="popup-image" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1" role="dialog"
   aria-labelledby="modal-label" style="display: none">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" id="heightWidthModal2">
      <div class="modal-content" id="modal-content">
        <div class="modal-header" style="height: 40px">
          <div class="col-11 text-center">
            <h6 class="modal-title">{{lang?.Execution_Screenshots}}</h6>
          </div>
        </div>

        <div class="modal-body" id="modal-body1">
          <!-- Displaying Images in a Gallery Style -->
          <table
              datatable 
              [dtOptions]="dtOptions2"
              [dtTrigger]="dtTrigger2"
              id="DataTables_Table_2">
            <thead>
              <tr>
                <th>{{lang?.Name}}</th>
                <th>{{lang?.Image}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let image of imageUrls;let i = index">
                <td class="w-100">{{imageNames[i]}}</td>
                <td>
                  <img style="width:300px;" [src]="image" alt="image {{i}}" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
            {{lang?.Close}}
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
